<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText">The <i>Advise and Consent</i> series is a landmark of political fiction, displaying a depth of insider Washington knowledge and a canvas of compelling characters that catapulted each novel to the top of the bestseller lists. At the end of the previous novel, <i>Preserve and Protect</i>, Allen Drury left his readers with one of the greatest cliffhangers of all time. After an assassin’s bullet rings out, we are left to wonder who was killed—the Liberal Vice President Ted Jason, or staunch Conservative Presidential Candidate Orrin Knox? The answer to that question was so large that Pulitzer-Prize winner Drury had to write two novels, one exploring the full ramifications of each outcome.</p>
<p class="P_WFP_BodyText">In <i>Come Nineveh, Come Tyre, </i>China and the Soviet Union are waiting and watching for any sign of weakness from the untried Ted Jason, survivor of the assassination attempt that took the life of Orrin Knox and catapulted him into the Presidency. Ted Jason has been thrust into this position of power—is he up to the challenge of leadership in such a time of crisis? Or will he bend too far toward appeasement, at the cost of freedom around the world?</p>
<p class="P_WFP_BodyText">Looking at the stakes for the United States against the backdrop of war, politics, and scandal, President Jason must play winner-take-all in this game of politics.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?151a7402